import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { useWeather } from "@/lib/weather";
import { WeatherIcon } from "@/components/WeatherIcon";

const deg = (t) => (t == null ? "–" : `${Math.round(t)}°`);

// Meteo compatto della città scelta, in cima al feed Per te.
export function WeatherStrip() {
  const { city, data } = useWeather();
  if (!city || !data) return null;
  return (
    <Link to="/meteo" data-testid="foryou-weather" className="group mb-6 flex items-center gap-4 rounded-2xl border border-hair bg-surfaceSecondary px-5 py-4 hover:border-brand/50 transition-colors">
      <WeatherIcon symbol={data.now.symbol} size={30} className="text-brand shrink-0" />
      <div className="flex-1 min-w-0">
        <p className="font-mono text-[11px] uppercase tracking-[0.16em] text-subtle truncate">Meteo · {city.name}</p>
        <p className="text-sm text-onSurface">
          <span data-testid="foryou-weather-temp" className="font-bold text-lg tabular-nums mr-2">{deg(data.now.temp)}</span>
          {data.now.label} · <span className="font-mono text-xs tabular-nums">min {deg(data.today.min)} · max {deg(data.today.max)}</span>
        </p>
      </div>
      <ChevronRight size={18} className="text-subtle group-hover:text-brand transition-colors" />
    </Link>
  );
}
